// React
import React from 'react';
import ReactDOM from 'react-dom';

// Redux
import { Provider } from 'react-redux';
import configureStore from '../../shop/scripts/store';

// CMS re-render events
import { CMS_EVENTS } from '../../shop/scripts/cms';

// Containers
import { CONTAINERS } from '../../shop/scripts/containers';

const initialState = {};

const store = configureStore(initialState);

/**
 * Load the components
 */
function loadComponents() {
  const domNodes = [...document.querySelectorAll('[data-component]')];

  domNodes.map((Element) => {
    const { component, props } = Element.dataset;

    try {
      const data = props ? JSON.parse(props) : {};
      const SrcContainer = CONTAINERS[`${component}`]();
      const elementChildren = Element.innerHTML;

      ReactDOM.render(
        <Provider store={store}>
          <SrcContainer elementChildren={elementChildren} {...data} />
        </Provider>,
        Element,
      );
    } catch (e) {
      console.error(`Error in parsing data for component: ${component}`, props, e);
    }
  });
}

CMS_EVENTS.load(loadComponents);

loadComponents();

export { CONTAINERS };
